const cssConfig = {
	themeColor: '#fa671f',
	rootFontSize: 37.5
}

module.exports = {
	cssConfig
}
